import { render, staticRenderFns } from "./ListPanel.vue?vue&type=template&id=2da3da68&scoped=true&"
import script from "./ListPanel.vue?vue&type=script&lang=js&"
export * from "./ListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ListPanel.vue?vue&type=style&index=0&id=2da3da68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3da68",
  null
  
)

export default component.exports